import styled from 'styled-components'

import type { ComponentPropsWithoutRef } from 'react'

/* ------------------------------------------------------------------------------------------------- *
 * MedicationPhotoButton
 * ------------------------------------------------------------------------------------------------- */

/** `aria-label` is required: the button only shows the photo. */
type MedicationPhotoButtonProps = ComponentPropsWithoutRef<'button'> & { 'aria-label': string }

/** Makes a photo thumbnail tappable, e.g. to open it full screen. */
const MedicationPhotoButton = ({ children, ...props }: MedicationPhotoButtonProps) => (
  <StButton type='button' {...props}>
    {children}
  </StButton>
)

export { MedicationPhotoButton }

/* ------------------------------------------------------------------------------------------------- *
 * Styled
 * ------------------------------------------------------------------------------------------------- */

const StButton = styled.button`
  display: flex;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
`
